import ContentLandingPage from './index';
import '@app/clp/styles.scss';
import '@app/clp/async.scss';

if (import.meta.webpackHot) {
  import.meta.webpackHot.accept('./', () => {
    console.clear();
    const tour = new ContentLandingPage();
    tour.initiate();
  });
}

window.addEventListener('load', () => {
  const tour = new ContentLandingPage();
  tour.initiate();
});
